export { FlashList as default } from "@shopify/flash-list";
